import React from 'react';
import {EMAIL_SENT, SIGN_IN} from "../../../constants/routes";
import {Link} from "react-router-dom";
import {parse} from "query-string";

/**
 * Sign up success page that prompts the user to verify the email
 * if it was successfully sent or sign in to resend the verification email.
 */
export const SignUpSuccess = (props) => {
    const email = parse(props.location.search).to;
    const isEmailSent = (props.match.params[EMAIL_SENT] === EMAIL_SENT) && email;
    return (
        <div className="container">
            <h1>New User Account Created</h1>
            {
                isEmailSent ?
                    <p>
                        We've just sent a verification email
                        to <Link to={SIGN_IN}>{email}</Link>.
                        Please verify your email
                        and <Link to={SIGN_IN}>sign in</Link> to
                        complete your account registration.
                    </p> :
                    <p>
                        A verification email was not able to
                        be sent at this time. You may continue
                        to <Link to={SIGN_IN}>sign in</Link> to
                        try sending the verification email again.
                    </p>
            }
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/auth/signup/SignUpSuccess.jsx